import { AlertState } from '@components/alert/types';

export const HORIZONTAL_ALERT_WIDTH = 260;
export const VERTICAL_ALERT_WIDTH = 270;
// shared by the container and the bottom button rounding so the corners stay flush
export const ALERT_BORDER_RADIUS = 11;

export const initialState: AlertState = {
  showAlert: false,
  loadingIndicator: false,
  titleColor: undefined,
  title: '',
  text: undefined,
  actions: [],
  position: 'horizontal',
  boldPrimary: false,
};
